<template>
  <div>
    <h1>商家运营人员管理</h1>
    <div>
      <el-form :model="form" inline>
        <el-form-item>
          <el-input v-model="form.admin_id" placeholder="商运ID"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="form.admin_name" placeholder="商运名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="form.status" placeholder="状态">
            <el-option value="0" label="全部"></el-option>
            <el-option
              v-for="item in selections.status"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间：">
          <el-date-picker
            v-model="form.created_at"
            type="datetimerange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="fetchTableData">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="output">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-header">
      <el-button
        style="background-color: #f90; color: #fff"
        size="small"
        @click="showDialog(0)"
        >创建商运名单</el-button
      >
    </div>
    <el-table :data="tableData.list">
      <el-table-column
        prop="admin_id"
        label="商运ID"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="admin_name"
        label="商运名称"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="status_name"
        label="状态"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="created_at"
        label="创建时间"
        align="center"
      ></el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="showDialog(1, scope.row)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="text-align: right"
      layout="total, prev, pager, next, jumper"
      background
      :current-page.sync="form.page"
      :page-size="form.page_size"
      :total="tableData.total"
      @current-change="fetchTableData"
    ></el-pagination>
    <el-dialog
      :visible.sync="dialog.show"
      :close-on-click-modal="false"
      width="500px"
      :title="`${dialog.is_edit ? '编辑' : '添加'}商运信息`"
    >
      <el-form
        ref="dialogForm"
        :model="dialog.data"
        label-width="100px"
        label-position="right"
        :inline="false"
        :rules="rules"
      >
        <el-form-item label="人员名称" prop="admin_id">
          <el-select
            v-model="dialog.data.admin_id"
            filterable
            style="width: 300px"
            :disabled="dialog.is_edit"
          >
            <el-option
              v-for="item in canAddAdminOptions"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="dialog.data.status" style="width: 300px">
            <el-option label="启用" value="1"></el-option>
            <el-option label="禁用" value="2"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="commit">确定</el-button>
        <el-button type="danger" @click="closeDialog">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";
import { postGetList } from "@/openapi/erp/businessOperator.js"; // 获取列表
import { getGetEnumsForList } from "@/openapi/erp/businessOperator.js"; // 列表枚举
import { postAddOne } from "@/openapi/erp/businessOperator.js"; // 新增商运人员
import { postUpdateOne } from "@/openapi/erp/businessOperator.js"; // 更新商运人员
import { getAllEnableAdmin } from "@/controller/supply2267.js"; // 获取可用人员

export default {
  data() {
    return {
      tableData: {
        list: [],
        total: 0,
      },
      form: {
        admin_id: "",
        admin_name: "",
        status: "",
        created_at: [],
        page: 1,
        page_size: 50,
        excel_export: 0,
      },
      selections: {
        status: [
          { value: 1, label: "启用" },
          { value: 2, label: "禁用" },
        ],
      },
      canAddAdminOptions: [],
      dialog: {
        show: false,
        is_edit: false,
        data: {
          admin_id: "",
          status: 0,
        },
      },
      rules: {
        admin_id: [{ required: true, message: "请选择人员名称" }],
      },
    };
  },

  created() {
    this.fetchTableData();
    this.getOptions();
  },

  methods: {
    // 获取列表
    fetchTableData() {
      postGetList(this.form).then((rs) => {
        this.$set(this.tableData, "list", rs.list);
        this.$set(this.tableData, "total", rs.total);
      });
    },
    // 导出列表
    output() {
      this.form.excel_export = 1;
      postGetList(this.form)
        .then((rs) => {
          window.open(apiBaseURL + rs.file);
        })
        .finally((_) => {
          this.form.excel_export = 0;
        });
    },
    // 获取可添加的用户信息
    fetchCanAddAdmin() {
      if (this.canAddAdminOptions.length > 0) return;
      getAllEnableAdmin().then((rs) => {
        this.canAddAdminOptions = rs.enable_admin_list;
      });
    },
    // 获取选项值
    getOptions() {
      getGetEnumsForList().then((rs) => {
        this.selections = rs;
      });
    },
    // 编辑/添加按钮
    showDialog(is_edit, row) {
      this.fetchCanAddAdmin();
      row = row || {};
      this.dialog.data = { ...row };
      this.$set(this.dialog, "is_edit", !!is_edit);
      this.$set(this.dialog, "show", true);
      this.$nextTick((_) => this.$refs.dialogForm.clearValidate());
    },
    // 确定提交
    commit() {
      this.$refs.dialogForm.validate((validate) => {
        if (!validate) {
          return false;
        }
        const apiCall = this.dialog.is_edit ? postUpdateOne : postAddOne;
        apiCall(this.dialog.data)
          .then(() => {
            this.$message.success("success");
            this.closeDialog();
            this.resetForm();
            this.fetchTableData();
          })
          .catch();
      });
    },
    resetForm() {
      this.form = {
        admin_id: "",
        admin_name: "",
        status: "",
        created_at: [],
        page: 1,
        page_size: 50,
        excel_export: 0,
      };
    },
    // 关闭弹窗
    closeDialog() {
      this.$set(this.dialog, "data", {
        admin_id: "",
        status: 0,
      });
      this.$set(this.dialog, "is_edit", false);
      this.$set(this.dialog, "show", false);
    },
  },
};
</script>

<style scoped>
.table-header {
  text-align: right;
  background-color: #eee;
  padding: 5px 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/picker/MerchantOperator.vue